import React from 'react';

function SearchField({
  value,
  onChange,
  placeholder = 'Search products...',
  style = {},
  className = '',
}) {
  return (
    <div className="position-relative w-100">
      <input
        type="text"
        className={`form-control w-100 listing-search br_25 ps-5 ${className} fw_600`}
        // style={{ maxWidth: 250, minWidth: 180, ...style }}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        lang="en"
      />
      <i
        className="fa-solid fa-magnifying-glass text-gray-500 position-absolute"
        style={{ left: '19px', top: '12px', pointerEvents: 'none' }}
      ></i>
    </div>
  );
}

export default SearchField;
